export default "__VITE_ASSET__393527f1__"